import classNames from 'classnames';
import { useState, useEffect, useRef } from 'react';
import { TemplateClassNames } from '../../../types/template-layouts';
import { capitalize } from '../../../utils/utils';
import './tab-header.scss';

interface ITabHeaderProps {
	defaultTab?: string;
	tabs: string[];
	append?: any;
	onClick: (tab: any) => any;
	currentTab?: string;
	renderTab?: (tab: string) => JSX.Element;
	template?: TemplateClassNames;
}

export default function TabHeader(props: ITabHeaderProps): JSX.Element {
	const { defaultTab, tabs, append, onClick, currentTab, template, renderTab } = props;

	const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]);
	const tabRefs = useRef<any>({});

	function clickTab(tab: string) {
		return () => {
			setActiveTab(tab);
			onClick(tab);
		};
	}

	useEffect(() => {
		if (currentTab) {
			setActiveTab(currentTab);
		}
	}, [currentTab]);

	return (
		<div className={classNames("tab-header-container", template ? `evt-tab-header ${template}` : "")}>
			<div className="tab-header-buttons">
				{tabs.map((tab: string, index: number) => (
					<div className="tab-header-button" key={`header-button ${tab}`}>
						<button
							className={classNames({ active: activeTab === tab })}
							key={tab}
							onClick={clickTab(tab)}
							ref={(ref) => (tabRefs.current[tab] = ref)}
						>
							{renderTab ? renderTab(capitalize(tab)) : <> {tab}
								{append ? (
									append[index] ? (
										` ${append[index]}`
									) : (<></>)
								) : (<></>)}</>}
						</button>
					</div>
				))}
			</div>
		</div>
	);
}
